import React, { forwardRef, useRef, useImperativeHandle } from "react";
import { Container } from "@pixi/react";

// x used to be hardcoded 0 because the parent reel container supplied the
// column offset. The overlay is flat now — all 15 symbols are siblings so they
// can sort against each other by z-index — so each one carries its own x.
export const OverlaySymbol = forwardRef(({ index, reelIndex = 0, x = 0, y }, ref) => {
  const containerRef = useRef(null);

  // Expose container ref directly
  useImperativeHandle(ref, () => containerRef.current);

  return (
    <Container
      ref={containerRef}
      y={y}
      x={x}
      zIndex={6}
      sortableChildren
      name={`spine_overlay_symbol_${reelIndex}_${index}`}
    />
  );
});

export default OverlaySymbol;
